import Home from './Pages/Home';
import Signin from './Pages/Signin'
import { BrowserRouter as Router, Switch, Redirect, Route } from "react-router-dom";
import MemberDashboard from './Pages/Dashboard/MemberDashboard/MemberDashboard.js';
import Allbooks from './Pages/Allbooks';
import BookDetails from './Pages/BookDetails';
import Header from './Components/Header';
import AdminDashboard from './Pages/Dashboard/AdminDashboard/AdminDashboard.js';
import StaffDashboard from './Pages/Dashboard/StaffDashboard/StaffDashboard.js';
import StaffManagement from './Components/StaffManagement';
import { useContext } from "react"
import { AuthContext } from "./Context/AuthContext.js"

function App() {

  const { user } = useContext(AuthContext)

  return (
    <Router>
      <Header />
      <div className="App">
        <Switch>
          <Route exact path='/'>
            <Home />
          </Route>
          <Route exact path='/signin'>
            {user ? (
              user.isAdmin ? <Redirect to='/dashboard@admin' /> : 
              (user.userType === 'staff' || user.userType === 'employee') ? <Redirect to='/dashboard@staff' /> :
              <Redirect to='/dashboard@member' />
            ) : <Signin />}
          </Route>
          <Route exact path='/dashboard@member'>
            {user ? (user.userType === 'student' ? <MemberDashboard /> : <Redirect to='/' />) : <Redirect to='/' />}
          </Route>
          <Route exact path='/dashboard@admin'>
            {user ? (user.isAdmin === true ? <AdminDashboard /> : <Redirect to='/' />) : <Redirect to='/' />}
          </Route>
          <Route exact path='/dashboard@staff'>
            {user ? (['staff', 'employee'].includes(user.userType) ? <StaffDashboard /> : <Redirect to='/' />) : <Redirect to='/' />}
          </Route>
          <Route exact path='/staff-management'>
            {user?.isAdmin || (user?.permissions?.canManageUsers) ? <StaffManagement /> : <Redirect to='/' />}
          </Route>
          <Route path='/books' exact>
            <Allbooks />
          </Route>
          <Route path='/books/:id'>
            <BookDetails />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;